<template>
  <div>
    <!-- 左下标题头 -->
    <!-- 组件d86d3f90-3deb-11ec-a2e6-953464dcce14开始-->
    <div
      id="itemd86d3f90-3deb-11ec-a2e6-953464dcce14"
      :style="{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px',
        lineHeight: '1.5',
        color: '#ffffff',
        textAlign: 'center',
        textShadow: false ? '0px 0px 14px rgba(15, 146, 255,1)' : '',
      }"
      class="centertitle"
    >
      <p>重点企业行业划分</p>
    </div>
    <!-- 组件d86d3f90-3deb-11ec-a2e6-953464dcce14结束-->
    <!-- 左下echart图展示区域 -->
    <!-- 组件57e5c2f0-3e1a-11ec-9ac5-c10a0ae21a86开始-->
    <div id="item57e5c2f0-3e1a-11ec-9ac5-c10a0ae21a86"></div>
    <div id="leftBottomShowWindow2">
      <div class="innerBox">
        <div id="leftBottomEchartsBox21"></div>
      </div>
    </div>
    <!-- 组件57e5c2f0-3e1a-11ec-9ac5-c10a0ae21a86结束-->
    <!-- 左下容器背景图 -->
    <!-- 组件85e23400-9797-4236-9be8-186a0b1f24e2开始-->
    <div id="item85e23400-9797-4236-9be8-186a0b1f24e2">
      <img src="../../../assets/images/线框.png" alt="" :style="{ width: '100%', height: '100%' }" />
    </div>
    <!-- 组件85e23400-9797-4236-9be8-186a0b1f24e2结束-->
  </div>
</template>

<script>
import axios from 'axios'
import * as echarts from 'echarts'
import { baseURL } from '../../../api/base'
export default {
  mounted () {
    this.setEcharts('leftBottomEchartsBox21', 0)
  },
  data () {
    return {
      // 模拟数据
      resData: [
        {
          totalPlanAmount: 79741.98, // 组织形式对应项目总预算
          wayType: '委托国采', // 组织形式名称
          capitalSavingRate: 0.2788, // 组织形式对应资金节约率
          projectNums: 61, // 组织形式对应项目数量
          totalLastPrice: 57508.2 // 组织形式对应总成交（中标）金额
        },
        {
          totalPlanAmount: 458045.91,
          wayType: '自行组织',
          capitalSavingRate: 0.1246,
          projectNums: 305,
          totalLastPrice: 400961.27
        },
        {
          totalPlanAmount: 26082.62,
          wayType: '委托代理机构',
          capitalSavingRate: 0.1329,
          projectNums: 6,
          totalLastPrice: 22615.66
        }
      ]
    }
  },
  methods: {
    /*
      创建echarts图
      @param id: 要画echarts的容器
      @param flag: 统计项目的内容
      - flag = 1 : 统计内容为项目数量柱状图
      - flag = 0 : 统计内容为项目预算柱状图、中标金额柱状图和资金节约率折线图
    */
    async setEcharts (id) {
      const xData = [];
      const showEchartsData =[
            {
              name: '重点企业行业划分',
              type: 'bar',
              barWidth: 30, // 柱图宽度
              data: []
            }
          ]
      await axios.post(baseURL+'/api2/getfields',{}).then(response=>{
          if(response.data){
             this.resData=response.data.statistic;
             const rawData = JSON.parse(JSON.stringify(this.resData));
      Object.keys(rawData).forEach(key => {
        if (key !== '__ob__') { // 过滤 Vue 内部属性
            console.log(rawData[key]);
               xData.push(key)
               showEchartsData[0].data.push(rawData[key])
        }
      });
          }
      }).catch(error => console.error(error))
      var chartDom = document.getElementById(id)
      var myChart = echarts.init(chartDom)
      var option
      option = {
  tooltip: {
    show: true,
    trigger: 'axis', // 修正为 axis 触发坐标轴提示
    axisPointer: {   // 添加指针类型配置
      type: 'shadow' // 阴影指示器
    },
    formatter: (params) => {
      const data = params[0];
      return `${data.name}<br/>数量: ${data.value}家`; // 优化显示格式
    }
  },
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: { interval: 0 }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '重点企业行业划分' ,
            axisLabel: {
              formatter: '{value}',
              rotate:  '0' // y轴字体倾斜角度
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#375C77'
              }
            }
          }
        ],
        series: showEchartsData
      }
      console.log(option)
      option && myChart.setOption(option)
    },
    /*
      banner滚动
      @param n: 当前展示的第几张图，从0开始
      @param bufferMove: 函数(能够实现元素的减速运动)
    */
    // changeBanner (n, bufferMove) {
    //   const bannerWrap = document.querySelector('#leftBottomShowWindow2 .innerBox')
    //   if (n === 3) {
    //     bannerWrap.style.left = 0
    //     n = 1
    //   }
    //   bufferMove(
    //     bannerWrap,
    //     {
    //       left: -n * 450
    //     },
    //     30
    //   )
    // }
  }
}
</script>

<style scoped>
/* 背景图位置及大小 */
#item85e23400-9797-4236-9be8-186a0b1f24e2 {
  top: 640px;
  left: 20px;
  width: 530px;
  height: 310px;
}
/* 标题位置 */
#itemd86d3f90-3deb-11ec-a2e6-953464dcce14 {
  top: 654px;
}
#leftBottomShowWindow2 {
  position: absolute;
  left: 70px;
  top: 680px;
  width: 450px;
  height: 270px;
  overflow: hidden;
}
#leftBottomShowWindow2 .innerBox {
  display: flex;
  position: absolute;
  top: 14px;
  left: 0px;
  height: 270px;
  width: 1350px;
}
#leftBottomShowWindow2 .innerBox div {
  position: absolute;
  top: 0;
  width: 450px;
  height: 270px;
  z-index: 8;
  opacity: 1;
  transform: rotate(0deg);
  background: rgba(255, 255, 255, 0);
  border: 0px solid #2ed64a;
  border-radius: 0px;
  padding: 0px;
}
#leftBottomEchartsBox21 {
  left: 0px;
}
</style>
